import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51b0c3b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-mild section-title" }, "招待の手順", -1))
const _hoisted_2 = { class: "d-flex flex-column mt-2 gap-8" }
const _hoisted_3 = { class: "d-flex step-section" }
const _hoisted_4 = { class: "d-flex flex-column flex-grow-1 gap-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "step-number mr-1" }, "1"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", null, "招待コードを招待したい方に送る")
], -1))
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "text-mild text-size-28 text-weight-700 pt-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-mild mr-1" }, "コピー", -1))
const _hoisted_9 = { class: "d-flex step-section" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column gap-8" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "step-number mr-1" }, "2"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", null, "カイテクに登録、資格認証を行う")
  ]),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-start" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "step-number mr-1" }, "3"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("「マイページ＞招待キャンペーン」"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("\n              から招待コードを登録")
    ])
  ])
], -1))
const _hoisted_11 = { class: "d-flex step-section" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "step-number mr-1" }, "4"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("span", null, "初勤務完了後に即時ポイント付与")
  ])
], -1))
const _hoisted_13 = { class: "mx-2 my-4" }
const _hoisted_14 = { class: "text-mild section-title mb-2" }
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = { class: "text-size-14 flex-grow-1 d-flex flex-column align-items-center border-right pr-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "獲得した仲間", -1))
const _hoisted_18 = { class: "font-weight-bold" }
const _hoisted_19 = { class: "text-size-32 highlight" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-size-20 highlight" }, "人", -1))
const _hoisted_21 = { class: "text-size-14 flex-grow-1 d-flex flex-column align-items-center pl-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "獲得したポイント", -1))
const _hoisted_23 = { class: "font-weight-bold" }
const _hoisted_24 = { class: "text-size-32 highlight" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-size-20 highlight" }, "pt", -1))

import { PropType, computed } from "vue";
import { User } from "@/types/user/User";
import { ReferPromotion } from "@/types/refer_promotion/ReferPromotion";
import BgWaveCard from "@/components/organisms/common/BgWaveCard.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import ReferAttention from "@/components/organisms/mypage/referPromotion/ReferAttention.vue";
import { formatNumber } from "@/utils/number";
import { deviceModule } from "@/store/device";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferrerTab',
  props: {
  promotion: {
    type: Object as PropType<ReferPromotion>,
    required: true
  },
  userData: {
    type: Object as PropType<User>,
    required: true
  },
  pointAppliedPromotion: {
    type: Number,
    required: true
  },
  countAppliedPromotion: {
    type: Number,
    required: true
  }
},
  emits: ["click"],
  setup(__props, { emit: emits }) {

const props = __props;



const fullName = computed(() => {
  return props.userData?.fullName ?? "";
});

const formattedPointAppliedPromotion = computed(() => {
  return formatNumber(props.pointAppliedPromotion);
});

const isIos = computed(() => {
  return deviceModule.isIos;
});

const sideFlowClass = computed(() => {
  return `side-flow ${isIos.value ? "" : "side-flow-not-ios"}`;
});



const onClick = () => {
  emits("click");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createTextVNode(),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(sideFlowClass.value)
          }, "\n          あなた\n        ", 2),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(),
            _createVNode(BgWaveCard, { class: "w-100" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(__props.promotion.code), 1),
                  _createTextVNode(),
                  _createElementVNode("p", {
                    class: "text-mild text-size-14 ml-auto",
                    onClick: onClick
                  }, [
                    _hoisted_8,
                    _createTextVNode(),
                    _createVNode(FeatherIcon, {
                      size: "20",
                      icon: "copy"
                    })
                  ])
                ])
              ], undefined, true),
              _: 1
            })
          ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass(sideFlowClass.value)
          }, "\n          招待された方\n        ", 2),
          _createTextVNode(),
          _hoisted_10
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: _normalizeClass(sideFlowClass.value)
          }, "\n          あなた\n        ", 2),
          _createTextVNode(),
          _hoisted_12
        ])
      ])
    ]),
    _createTextVNode(),
    _createVNode(ReferAttention),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("p", _hoisted_14, _toDisplayString(fullName.value) + "さまの招待実績\n    ", 1),
      _createTextVNode(),
      _createVNode(BgWaveCard, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(__props.countAppliedPromotion), 1),
                _hoisted_20
              ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(formattedPointAppliedPromotion.value), 1),
                _createTextVNode(),
                _hoisted_25
              ])
            ])
          ])
        ], undefined, true),
        _: 1
      })
    ])
  ], 64))
}
}

})